module.exports = __webpack_public_path__ + "img/icon-trash.f1c01a23.svg";